import React, { useEffect, useState, useRef } from "react";
import "../../CommonContainer/common.css";
import "../HomeSection/index.css";
import Header from "../../Layouts/Header.jsx";
import { useNavigate } from "react-router-dom";

import AOS from 'aos';
import 'aos/dist/aos.css';

import img11 from "../../../Assets/images/homeimages/banner-dispaly-1.png";
import bgPattern from "../../../Assets/images/homeimages/banner5.png";
import testimonialImage from "../../../Assets/images/homeimages/testimonial-image.png";

import himg from "../../../Assets/images/home-img.png"

// images
import img1 from "../../../Assets/images/homeimages/img1.jpg";
import img2 from "../../../Assets/images/homeimages/img2.jpg";
import img3 from "../../../Assets/images/homeimages/img3.jpg";
import img4 from "../../../Assets/images/homeimages/img4.jpg";
import img5 from "../../../Assets/images/homeimages/img5.jpg";
import img6 from "../../../Assets/images/homeimages/img6.jpg";
import img7 from "../../../Assets/images/homeimages/img7.jpg";
import img8 from "../../../Assets/images/homeimages/img8.jpg";

import test1 from "../../../Assets/images/homeimages/test1.png"  
import test2 from "../../../Assets/images/homeimages/test2.png"

import furniture from "../../../Assets/images/furniture.png"

import logo from "../../../Assets/images/logo.png" 

const Home = () => {
  const images = [img11, img1, img2, img3, img4, img5, img6, img7, img8];
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [fade, setFade] = useState(false);
  const [reviews, setReviews] = useState([]);
  const mapRef = useRef(null);

  const navigate= useNavigate();

  // Banner Image Slideshow
  useEffect(() => {
    const interval = setInterval(() => {
      setFade(true);
      setTimeout(() => {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
        setFade(false);
      }, 500);
    }, 3000);
    return () => clearInterval(interval);
  }, [images.length]);

  // Google Reviews Fetch (Frontend-only, No CORS issue)
  useEffect(() => {
    const loadReviews = () => {
      if (!window.google || !mapRef.current) return;

      const service = new window.google.maps.places.PlacesService(mapRef.current);
      service.getDetails(
        {
          placeId: "ChIJK05zBgApODoRKrwz-c22-Ak", // Your place ID
          fields: ["reviews"],
        },
        (place, status) => {
          if (status === window.google.maps.places.PlacesServiceStatus.OK) {
            setReviews(place.reviews || []);
          } else {
            console.error("Failed to fetch reviews:", status);
          }
        }
      );
    };

    const interval = setInterval(() => {
      if (window.google && mapRef.current) {
        clearInterval(interval);
        loadReviews();
      }
    }, 100);
  }, []);

  const onexplore = () => {
  navigate("/jewellery");
}
const viewmore = () =>{
  navigate("/contact-us")
}

const onexplorenew = ()=>{
  navigate("/articles")
}


const furnitureclick = () =>{
  navigate("/furniture")
}

  return (
    <>
      <div className="common-main-app-continer">
        <div className="home-banner-section">
          <Header />
          <div className="common-width-home-main-container">
            <div className="header-content-section">
              <div>
                <h1>Where Silver Speaks Heritage, and Gold Whispers Grace</h1>
                <p>Explore Sreerasthu’s world of majestic jewellery and artisan furniture.</p>
                <button type="button" onClick={onexplore}>Explore</button>
              </div>
              <img src={himg} alt="img1" className="banner-dipaly-images" data-aos="zoom-in-up" />
            </div>
          </div>
        </div>

        {/* second section */}
        <div className="section-home-banner">
          <div className="common-width-home-main-container">
            <div className="second-section-content">
              <h2 className="silver-heading">
                <span className="line" />
                <p> Timeless Creations in</p>{" "}
                <span className="silver-text">
                  <p>92.5 Silver</p>
                </span>
                <span className="line" />
              </h2>
              <h2 className="m-h">Timeless Creations in 92.5 Silvers</h2>
              <p className="silver-subtext">
                From gold-polished silver jewelry that radiates grace, to majestic furniture <br />
                that defines luxury, and sacred idols that honor tradition
              </p>

              <div className="inner-banner-section-2 inner-banner-bg">
                <h1 className="welcome-heading">Welcome To Sreerasthu</h1>
                <p className="welcome-subtext">
                  Sreerasthu curates handcrafted treasures in pure 92.5 silver. <br />
                  Designed for elegance. Made to last forever
                </p>
                <button className="welcome-button" onClick={viewmore}>View More</button>
              </div>
            </div>
          </div>
        </div>

        {/* third section */}
        <div className="third-home-banner">
          {/* <div className="common-width-home-main-container">
            <img src={furniture} alt = "furniture"/>
          </div> */}
            <img src={furniture} alt = "furniture"/>

            <div className="furniture-content">
              <h1>Statement Furniture in 999 Silver</h1>
              <p>Handcrafted to perfection, our silver furniture blends timeless artistry with royal elegance.</p>
              <button type="button" onClick={ furnitureclick}>Explore</button>
            </div>
        </div>



        {/* fourth section */}
        <div className="fourth-home-banner">
          <div className="common-width-home-main-container">
            <div className="inner-banner-section-4">
              <div className="new-arrivals-card">
                <div className="new-arrivals-logo">
                  <img src={logo} alt="logo" />
                </div>
                <h2 className="new-arrivals-title">New Arrivals</h2>
                <p className="new-arrivals-text">
                  Discover the latest additions to our 92.5 silver collection — freshly
                  crafted, beautifully detailed, and ready to become your next
                  treasured piece.
                </p>
                <button className="new-arrivals-button" onClick={onexplorenew}>Explore</button>
              </div>
            </div>
          </div>
        </div>

        {/* Testimonials section (Google Reviews) */}
        <div
          className="testimonial-section"
          style={{ backgroundImage: `url(${bgPattern})` }}
        >
          <div className="testimonial-container">
            <div className="testimonial-left">
              <img src={test1} alt="test1" />
              <h2 className="testimonial-heading">Testimonials</h2>
              <div className="stars">★ ★ ★ ★ ★</div>
              <p className="testimonial-quote">
                “I've never seen such detailed craftsmanship in silver jewelry. The
                gold polish adds such elegance — people often mistake it for real
                gold! Truly timeless pieces.”
              </p>
              <p className="testimonial-author">
                <span>Ankita R.</span>, Hyderabad
              </p>
              <img src={test2} alt="test2" />
            </div>
            <div className="testimonial-right">
              <img src={testimonialImage} alt="Testimonial" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
